import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  defaultProfileCompleteness, profileCompletenessType, calculateScore, updateCompleteness,
} from './score';
import Indicator from './indicator';

const Title = styled.h1`
  font: ${props => props.theme.fontWeightMedium} 20px/100% ${props => props.theme.fontFamilyBody};
  margin: 0;
  padding: 0;
  padding-top: 34px;
  text-transform: uppercase;

  ${props => props.showIndicator && props.theme.isMobile && `
    &.new-nav {
      padding-top: 60px;
    }
  `};

  ${props => props.showIndicator && props.theme.isBumpView && `
    padding-top: 74px;

    &.new-nav {
      padding-top: 110px;
    }
  `};

  & > strong {
    font-weight: ${props => props.theme.fontWeightBlack};
  }

  & > .separator {
    font-weight: ${props => props.theme.fontWeightBlack};
    color: ${props => props.theme.primaryColor};
    margin: 0 12px;
  }

  & > .anchor {
    font: ${props => props.theme.fontWeightDccc} 19px/20px ${props => props.theme.fontFamilyBody};
    text-transform: none;
  }
  &:after {
    display: block;
    content: "";
    margin: 14px 0;
    border-bottom: 1px solid ${props => props.theme.primaryColor};
  }
`;

const Paragraph = styled.p`
  margin-top: 0;
  color: ${props => props.theme.bodyColor};
`;

const Header = React.forwardRef(({
  title, desc, showProfileLink, profileCompleteness, newNavEnabled,
}, ref) => {
  const [completeness, setCompleteness] = React.useState(profileCompleteness);

  const update = d => setCompleteness(updateCompleteness(completeness, d));

  React.useImperativeHandle(ref, () => ({ update }));

  const i = _.indexOf(title, ' ');
  const first = i < 0 ? title : _.slice(title, 0, i).join('');
  const remains = i < 0 ? null : _.slice(title, i, title.length).join('');

  const profileSlug = _.get(window, 'Livewire.currentUser.profile.slug');
  const isContributor = _.get(window, 'Livewire.currentUser.profile.canPostWires');

  const percent = calculateScore(completeness);
  const showIndicator = isContributor && percent < 1;

  return (
    <header>
      <Title showIndicator={showIndicator} className={newNavEnabled ? 'new-nav' : ''}>
        <strong>{first}</strong>
        {remains}
        {!!showProfileLink && !!profileSlug && !!isContributor && (
          <>
            <span className="separator">&bull;</span>
            <a className="anchor" href={`/contributors/${profileSlug}`}>View Profile</a>
          </>
        )}
        {!!showIndicator && <Indicator percent={percent} newNavEnabled={newNavEnabled} />}
      </Title>
      {!!desc && <Paragraph>{desc}</Paragraph>}
    </header>
  );
});

Header.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string,
  showProfileLink: PropTypes.bool,
  profileCompleteness: profileCompletenessType,
  newNavEnabled: PropTypes.bool,
};

Header.defaultProps = {
  desc: null,
  showProfileLink: false,
  profileCompleteness: defaultProfileCompleteness,
  newNavEnabled: false,
};

Header.displayName = 'Header';

export default Header;
